import Swiper, { Navigation } from 'swiper'

export function employeeSwiper() {
  document.addEventListener('DOMContentLoaded', () => {
    const sliderWrappers = document.querySelectorAll('.mtt-employees')

    if (sliderWrappers.length > 0) {
      sliderWrappers.forEach(sliderWrapper => {
        const swiperElement = sliderWrapper.querySelector('.mtt-employees__swiper')
        const nextButton = sliderWrapper.querySelector('.swiper-next')
        const prevButton = sliderWrapper.querySelector('.swiper-prev')

        const swiperOptions = {
          modules: [Navigation],
          speed: 600,
          spaceBetween: 12,
          slidesPerView: 1.15,
          threshold: 8,
          grabCursor: true,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton
          },
          breakpoints: {
            451: {
              slidesPerView: 1.5
            },
            501: {
              slidesPerView: 2.15
            },
            580: {
              slidesPerView: 2.5
            },
            761: {
              slidesPerView: 3
            },
            961: {
              slidesPerView: 3.5
            },
            1161: {
              slidesPerView: 4
            }
          }
        }

        const swiper = new Swiper(swiperElement, swiperOptions)
      })
    }
  })
}